module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('boxWrap', {
    attrs: {
      "name": _vm.name
    }
  }, [_c('div', {
    staticClass: "circleBar"
  }, [_c('div', {
    staticClass: "main"
  }), _vm._v(" "), _vm._l((_vm.data), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "active-item"
    }, [_c('i', {
      staticClass: "item-rank",
      style: (_vm.changeColor(index))
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "item-name-num"
    }, [_c('span', {
      staticClass: "item-name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('em', {
      staticClass: "item-num"
    }, [_vm._v(_vm._s(item.num))])])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d3ae392!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/circleBar/index.vue
// module id = 1952
// module chunks = 2